import Head from 'expo-router/head';

import { ScreenCustomizeItem } from '@fhs/menu/src/screens/screen-customize-item';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function CustomizeItemPage() {
  return (
    <>
      <Head>
        <title>Customize - Firehouse Subs</title>
      </Head>
      <ScreenCustomizeItem />
    </>
  );
}
